export { default as DocumentTitleWithIcon } from './document-title-with-icon';
